import * as Survey from "survey-react";
import "survey-react/survey.css";
import "./survey-theme.css";
import React from 'react'
import axios from "axios";
import config from "../../constants";
import survey from "./survey_new.json"

const OrsSurvey = () => {

  const model = new Survey.Model(survey);

  const storageName = "SurveyJS_state";

  function loadState(survey) {
    const data = window.localStorage.getItem(storageName);
    console.log(data);
    if (data) {
      const res = JSON.parse(data);
      if (res.data) survey.data = res.data;
      if (res.currentPageNo) survey.currentPageNo = res.currentPageNo;
    }
  }

  function saveState(survey) {
    var res = { currentPageNo: survey.currentPageNo, data: survey.data };
    try {
      window.localStorage.setItem(storageName, JSON.stringify(res));
    } catch (e) {
      console.error(e);
      alert("Cannot save survey data to local storage");
    }
  }

  function clearStorage() {
    window.localStorage.removeItem(storageName);
  }

  model.onValueChanged.add(saveState);
  model.onCurrentPageChanged.add(saveState);

  // Check email limit after completing the first page
  model.onCurrentPageChanging.add(async (sender, options) => {
    // If leaving the first page (generalInformation), check the email limit
    if (sender.currentPage.name === "generalInformation" && options.isNextPage) {
      const email = sender.getValue("email");
      
      if (email) {
        try {
          const response = await axios.get(`${config.baseUrl}/check_email_limit/${encodeURIComponent(email)}`);
          
          if (response.data && !response.data.canSubmit) {
            // User has exceeded the limit
            options.allow = false; // Prevent page navigation
            
            // Show error message
            alert(`You have already been granted ${response.data.requestCount} Academic License(s) in the last 365 days. Our program allows a maximum of ${response.data.maxRequests} licenses per year.\n\nPlease contact our sales team (sales.dragonfly@comet.tech) to discuss additional licensing options.`);
          }
        } catch (error) {
          console.error("Error checking email limit:", error);
          // Allow progression on error to avoid blocking users due to network issues
        }
      }
    }
  });

  model.onComplete.add(survey => {
    saveState(survey);
    axios.post(config.serverUrl, survey.data)
      .then((response) => {
        if (response.data && response.data.limitExceeded) {
          survey.completedHtml = `
            <h2>Dragonfly Academic License Request Limit Reached</h2>
            <p>Our Dragonfly 3D World "Academic License" program allows qualified Academics to receive a maximum of 2 licenses within a 365-day period. You are at this limit, and we cannot grant any further free licenses at this time.</p>
            <p>Please contact our sales team (<a href="mailto:sales.dragonfly@comet.tech">sales.dragonfly@comet.tech</a>) to discuss additional licensing options.</p>
          `;
        } else {
          survey.completedHtml = "<h2>Success! Thank you for completing the survey!</h2><br/><br/><br/><h2>Your request is being reviewed.  Due to the large number of requests this may take up to 2 business days. Please make sure to check your spam folder as well.</h2>";
        }
        survey.render();
        clearStorage();
      })
      .catch(err => {
        survey.completedHtml = `<h2>An error occurred: ${err.message}</h2>`;
        survey.render();
      });
  });

  loadState(model);

  return <Survey.Survey model={model} />;

};

export default OrsSurvey
